import React from "react";
import styles from "./ActionFooter.module.scss";
import Button from "@mui/material/Button";
import { withTranslation } from "react-i18next";

function ActionFooter(props) {
  return (
    <>
      {props.displayActionFooter ? (
        <div
          id="actionFooter"
          className={`${styles.actionFooter} actionFooter`}
        >
          <Button
            type="button"
            onClick={props.observer}
            className="saveBtn"
            id="save-action-footer-btn"
          >
            {props.actionName}
          </Button>
        </div>
      ) : null}
    </>
  );
}

export default withTranslation("emp")(ActionFooter);
